define("shared/components/shared/post/sandbox", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "later/config/environment", "later/utils/object-promise-proxy"], function (_exports, _component, _templateFactory, _object, _component2, _environment, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"later/config/environment",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! template-lint-disable no-bare-strings  }}
  {{#if this.isEnabled}}
    <Shared::Ui::Button @onClick={{this.debug}}>
      {{t "shared_words.log"}}
    </Shared::Ui::Button>
  
    {{#if (and @post.postedTime @post.isInstagram)}}
      <Shared::Ui::Button @onClick={{this.makeUnverified}}>
        {{t "post.make_unverified"}}
      </Shared::Ui::Button>
    {{/if}}
  
    {{#if @post.postedTime}}
      <Shared::Ui::Button @onClick={{this.makeUnposted}}>
        {{t "post.make_unposted"}}
      </Shared::Ui::Button>
    {{else if @post}}
      <Shared::Ui::Button @onClick={{this.makePosted}}>
        {{t "post.make_posted"}}
      </Shared::Ui::Button>
    {{/if}}
  {{/if}}
  */
  {
    "id": "5Wao19Mw",
    "block": "[[[41,[30,0,[\"isEnabled\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@onClick\"],[[30,0,[\"debug\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,2],[\"shared_words.log\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[28,[37,3],[[30,1,[\"postedTime\"]],[30,1,[\"isInstagram\"]]],null],[[[1,\"    \"],[8,[39,1],null,[[\"@onClick\"],[[30,0,[\"makeUnverified\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"post.make_unverified\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"postedTime\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@onClick\"],[[30,0,[\"makeUnposted\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"post.make_unposted\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,1],[[[1,\"    \"],[8,[39,1],null,[[\"@onClick\"],[[30,0,[\"makePosted\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"post.make_posted\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]],null]],[]]]],[]],null]],[\"@post\"],false,[\"if\",\"shared/ui/button\",\"t\",\"and\"]]",
    "moduleName": "shared/components/shared/post/sandbox.hbs",
    "isStrictMode": false
  });

  let PostSandboxComponent = (_class = class PostSandboxComponent extends _component2.default {
    get isEnabled() {
      return _environment.default.APP.postModalSandbox && _environment.default.APP.environment === 'development';
    }

    async debug() {
      console.info(this);
      console.info('PostModel', this.args.post);
      console.info('PostMediaItems', this.args.post.get('postMediaItems').forEach(pmi => {
        const {
          id,
          mediaUrl,
          ordering,
          croppedHeight,
          croppedWidth,
          aspectRatio,
          isDeleted,
          userTags
        } = pmi;
        console.log({
          id,
          mediaUrl,
          ordering,
          croppedHeight,
          croppedWidth,
          aspectRatio,
          isDeleted,
          userTags
        });
      }));
      console.log('MediaItem', await (0, _objectPromiseProxy.default)(this.args.post.firstMediaItem));
    }

    makeUnverified() {
      this.args.post.setProperties({
        autoPublish: false,
        verifiedTime: null
      });
    }

    makePosted() {
      this.args.post.setProperties({
        verifiedTime: moment().subtract(1, 'day').unix(),
        postedTime: moment().subtract(1, 'day').unix(),
        locked: true
      });
    }

    makeUnposted() {
      this.args.post.setProperties({
        verifiedTime: null,
        postedTime: null,
        locked: false
      });
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "debug", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "debug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeUnverified", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "makeUnverified"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makePosted", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "makePosted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeUnposted", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "makeUnposted"), _class.prototype)), _class);
  _exports.default = PostSandboxComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostSandboxComponent);
});